export default __webpack_public_path__ + "87cbbd6d68cb0e098afbcaff40deeda1.png";